import React from 'react';
import { UiToggle } from '../ui-kit/UiToggle';

/* eslint-disable react/prop-types */
export function UiToggleAdapter({ input, meta, ...rest }) {
  return <UiToggle {...input} {...rest} />;
}
